import { useCallback } from "react";
import { apiSlice } from "@/lib/api/apiSlice";
import { useAppDispatch } from "@/lib/hooks";

export function usePrefetchProduct() {
  const dispatch = useAppDispatch();

  return useCallback(
    (productId: string) => {
      if (!productId) {
        return;
      }

      void dispatch(
        apiSlice.endpoints.getProduct.initiate(productId, {
          subscribe: false,
        }),
      );
    },
    [dispatch],
  );
}
